/* tslint:disable */
/* eslint-disable */
/**
 * Pricing API
 * API for managing pricing.
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface LoanConfigWithGuaranteeIdsDto
 */
export interface LoanConfigWithGuaranteeIdsDto {
    /**
     * 
     * @type {string}
     * @memberof LoanConfigWithGuaranteeIdsDto
     */
    borrowerLoanId: string;
    /**
     * Insurance quota percentage
     * @type {number}
     * @memberof LoanConfigWithGuaranteeIdsDto
     */
    quota: number;
    /**
     * Insurance deductible amount
     * @type {number}
     * @memberof LoanConfigWithGuaranteeIdsDto
     */
    deductible: number;
    /**
     * Indicates if it's a capital insurance
     * @type {boolean}
     * @memberof LoanConfigWithGuaranteeIdsDto
     */
    isCapital: boolean;
    /**
     * Borrower role identifier
     * @type {string}
     * @memberof LoanConfigWithGuaranteeIdsDto
     */
    borrowerRoleId: string;
    /**
     * Option for psychological file buyback
     * @type {boolean}
     * @memberof LoanConfigWithGuaranteeIdsDto
     */
    isPsyBuyback: boolean;
    /**
     * Indicates if contribution exemption is active
     * @type {boolean}
     * @memberof LoanConfigWithGuaranteeIdsDto
     */
    isContribExempt: boolean;
    /**
     * Indicates if the configuration is active
     * @type {boolean}
     * @memberof LoanConfigWithGuaranteeIdsDto
     */
    isActive: boolean;
    /**
     * 
     * @type {Array<string>}
     * @memberof LoanConfigWithGuaranteeIdsDto
     */
    guaranteeIds: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof LoanConfigWithGuaranteeIdsDto
     */
    loanId: string;
}

/**
 * Check if a given object implements the LoanConfigWithGuaranteeIdsDto interface.
 */
export function instanceOfLoanConfigWithGuaranteeIdsDto(value: object): value is LoanConfigWithGuaranteeIdsDto {
    if (!('borrowerLoanId' in value) || value['borrowerLoanId'] === undefined) return false;
    if (!('quota' in value) || value['quota'] === undefined) return false;
    if (!('deductible' in value) || value['deductible'] === undefined) return false;
    if (!('isCapital' in value) || value['isCapital'] === undefined) return false;
    if (!('borrowerRoleId' in value) || value['borrowerRoleId'] === undefined) return false;
    if (!('isPsyBuyback' in value) || value['isPsyBuyback'] === undefined) return false;
    if (!('isContribExempt' in value) || value['isContribExempt'] === undefined) return false;
    if (!('isActive' in value) || value['isActive'] === undefined) return false;
    if (!('guaranteeIds' in value) || value['guaranteeIds'] === undefined) return false;
    if (!('loanId' in value) || value['loanId'] === undefined) return false;
    return true;
}

export function LoanConfigWithGuaranteeIdsDtoFromJSON(json: any): LoanConfigWithGuaranteeIdsDto {
    return LoanConfigWithGuaranteeIdsDtoFromJSONTyped(json, false);
}

export function LoanConfigWithGuaranteeIdsDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): LoanConfigWithGuaranteeIdsDto {
    if (json == null) {
        return json;
    }
    return {
        
        'borrowerLoanId': json['borrowerLoanId'],
        'quota': json['quota'],
        'deductible': json['deductible'],
        'isCapital': json['isCapital'],
        'borrowerRoleId': json['borrowerRoleId'],
        'isPsyBuyback': json['isPsyBuyback'],
        'isContribExempt': json['isContribExempt'],
        'isActive': json['isActive'],
        'guaranteeIds': json['guaranteeIds'],
        'loanId': json['loanId'],
    };
}

export function LoanConfigWithGuaranteeIdsDtoToJSON(json: any): LoanConfigWithGuaranteeIdsDto {
    return LoanConfigWithGuaranteeIdsDtoToJSONTyped(json, false);
}

export function LoanConfigWithGuaranteeIdsDtoToJSONTyped(value?: LoanConfigWithGuaranteeIdsDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'borrowerLoanId': value['borrowerLoanId'],
        'quota': value['quota'],
        'deductible': value['deductible'],
        'isCapital': value['isCapital'],
        'borrowerRoleId': value['borrowerRoleId'],
        'isPsyBuyback': value['isPsyBuyback'],
        'isContribExempt': value['isContribExempt'],
        'isActive': value['isActive'],
        'guaranteeIds': value['guaranteeIds'],
        'loanId': value['loanId'],
    };
}

